import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useRetrievePersonalCalendarHolidays,
  useAssignPersonalCalendarHolidays,
  useUnAssignPersonalCalendarHolidays,
  useRetrieveCalendarsHolidays,
} from "@planzone/view-models";

import { Identifiable, CalendarHolidays as Cal } from "@planzone/dto";
import { CalendarHolidaysSelection } from "./selectList";
import { Props } from "./types";
import styles from "./styles.scss";

function CalendarHolidays({ planzone, resource }: Props) {
  const { t } = useTranslation();

  const {
    calendarsHolidays,
    isRequestFailure: isRetrieveCalendarsHolidaysFailure,
    isRequestPending: isRetrieveCalendarsHolidaysPending,
    isRequestSuccess: isRetrieveCalendarHolidaysSuccess,
    retrieveCalendarHolidays,
  } = useRetrieveCalendarsHolidays();
  const {
    isRequestFailure,
    isRequestPending,
    isRequestSuccess,
    personalCalendarHolidays,
    retrievePersonalCalendarHolidays,
  } = useRetrievePersonalCalendarHolidays(resource);

  const {
    isRequestPending: isAssignRequestPending,
    assignPersonalCalendarHolidays,
  } = useAssignPersonalCalendarHolidays(resource);

  const { unAssignPersonalCalendarHolidays } =
    useUnAssignPersonalCalendarHolidays(resource);

  useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrievePersonalCalendarHolidays({ resource });
  }, [planzone, resource]);

  useEffect(() => {
    !isRetrieveCalendarsHolidaysFailure &&
      !isRetrieveCalendarsHolidaysPending &&
      !isRetrieveCalendarHolidaysSuccess &&
      retrieveCalendarHolidays(planzone);
  }, [planzone]);

  useEffect(() => {
    !isRetrieveCalendarsHolidaysFailure &&
      !isRetrieveCalendarsHolidaysPending &&
      !isRetrieveCalendarHolidaysSuccess &&
      retrieveCalendarHolidays(planzone);
  }, [planzone]);

  return (
    <div className={styles.calendarHolidaysContainer}>
      <div className={styles.calendarHolidaysGroup}>
        <div className={styles.calendarHolidaysWrapper}>
          <CalendarHolidaysSelection
            placeholder={t(
              "preferences.calendarHolidays.inputPersonalCalendarHolidays",
            )}
            selectedCalendarHolidays={
              personalCalendarHolidays && !!personalCalendarHolidays.uuid
                ? personalCalendarHolidays
                : null
            }
            calendarsHolidays={calendarsHolidays}
            isDisabled={isAssignRequestPending}
            resource={resource}
            select={(calendar: Identifiable<Cal>) => {
              assignPersonalCalendarHolidays({
                resource: resource,
                calendarHolidays: calendar,
              });
            }}
            clearSelection={() => {
              unAssignPersonalCalendarHolidays(resource);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export { CalendarHolidays };
